export default __webpack_public_path__ + "static/media/cc-com.329006e8.svg";